import PropTypes from 'prop-types';
import buttonSkinData from '../data/buttonSkinData';
import buttonSizeData from '../data/buttonSizeData';
import buttonBtnTypeData from '../data/buttonBtnTypeData';
import buttonTypeData from '../data/buttonTypeData';
import buttonTargetData from '../data/buttonTargetData';
var buttonSkin = PropTypes.oneOf(buttonSkinData);
var buttonSize = PropTypes.oneOf(buttonSizeData);
var buttonBtnType = PropTypes.oneOf(buttonBtnTypeData);
var buttonType = PropTypes.oneOf(buttonTypeData);
var buttonTarget = PropTypes.oneOf(buttonTargetData);
export default {
  buttonSkin: buttonSkin,
  buttonSize: buttonSize,
  buttonBtnType: buttonBtnType,
  buttonType: buttonType,
  buttonTarget: buttonTarget
};